import { Currency } from '@/core/currency/interfaces';

const MMK: Currency = {
    name: 'Myanmar Kyat',
    demonym: 'Myanmar',
    majorSingle: 'Kyat',
    majorPlural: 'Kyat',
    codeNumeric: '104',
    symbol: 'Ks',
    symbolNative: 'Ks',
    minorSingle: 'Pya',
    minorPlural: 'Pya',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'MMK',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default MMK;
